<template>
  <scroll-area>
    <template slot="body">
      <v-layout  column fill-height justify-start px-0 pt-0>
          <v-layout column fill-height>
            <v-layout  justify-start>
              <div class="active device_hide_button">           
                <div :class="deviceShow ? 'white device_hide_button_trigger_hide' : 'white device_hide_button_trigger_show'" 
                :data-testid="$options.name + '__btn__' + 'hideDeviceCard'"
                @click="() => hideDeviceCard()">
                  <v-tooltip v-if="deviceShow" left color="primary">
                    <v-icon v-if="deviceShow" small color="lightgrey" slot="activator">expand_less</v-icon>
                    <span class="white--text">{{ $t('hide device view') }}</span>
                  </v-tooltip>
                  <v-tooltip v-if="!deviceShow" left color="primary">
                    <v-icon v-if="!deviceShow" small color="lightgrey" slot="activator">expand_more</v-icon>
                    <span class="white--text">{{ $t('show device view') }}</span>
                  </v-tooltip>
                </div>
              </div>   

              <v-tabs
                light
                :data-testid="$options.name + '__tabs__'"
                v-model="panel"
                height="40px"
              >
                <v-tabs-slider color="transparent" style="height: 0px; max-width: 0px"></v-tabs-slider>
                <v-tab
                  class="font-weight-normal"
                  v-for="(place, index) in getPlaces"
                  :key="index"
                >
                  <template slot="default">
                    <div class="tab_wrapper">
                      <div :class="getPlaces[panel] == place ? 'tab__border' : 'custom-tab'">
                        {{ $t(place) }} 
                      </div>
                    </div>
                  </template>
                </v-tab>
              </v-tabs>

              <v-btn v-if="getPlaces[panel] == 'console'" 
                :data-testid="$options.name + '__btn__' + 'reconnectConsole'"
                @click="reconnectConsole()" small color="secondary">
                {{$t('connect')}}
              </v-btn>
            </v-layout>

            <v-layout v-if="deviceShow" pa-3>
              <v-layout v-if="getData.height" column shrink class="active device_card_show_area" :style="`height: ${getDeviceHeight * 2.3 + 56}px;`" justify-start pa-0>
                <v-layout shrink class="device_card_show_area" justify-center>                 
                  <v-layout justify-space-around shrink pb-2 pt-2>
                    <v-btn :color="sideView == 'front' ? 'primary' : 'secondary'" small outline dark 
                    :data-testid="$options.name + '__btn__' + 'front'"
                    @click="sideView = 'front'">
                      {{$t('mount_front')}}
                    </v-btn>
                    <v-btn :color="sideView != 'front' ? 'primary' : 'secondary'" small outline dark 
                    :data-testid="$options.name + '__btn__' + 'rear'"
                    @click="sideView = 'rear'">
                      {{$t('mount_rear')}}
                    </v-btn>
                  </v-layout>
                </v-layout>

                <v-layout shrink :style="`height: ${getDeviceHeight}px;`" justify-center align-center>
                  <component
                    is="device-card"
                    :scaleObj="2.3"
                    :data="getData"
                    :nodes="getLinks"
                    :selected="getActive"
                    :side="sideView"
                    :subscribed="true"
                  />
                </v-layout>
              </v-layout>
            </v-layout>

            <v-layout v-show="showRefs" fill-height justify-start align-start style="position: relative" pa-0>
              <v-tab-item 
                v-show="getPlaces[panel] == dashboard.title"
                v-for="dashboard in dashboards" 
                :key="dashboard.uid" style="height: 100%; width: 100%" class="tab-item">

                <dashboard-item
                  :object-id="data.$id"
                  :tags="dashboard.tags"
                  :url="dashboard.url"
                /> 
              </v-tab-item>

              <equipment-measures 
                ref="equipment-measures"
                v-if="getPlaces[panel] == 'monitoring'"
                :mode="'monitoring'"
                :nodes="getLinks" 
                :fields="getFields"
                :data="getData"
                :cabinet="cabinet"
                :closedUnits="closedUnits"
                @selected="(payload) => onSelected(payload)"
                @inventory="() => {showInventory(!showInventoryBar)}"
                @deviceReplacingLoadDevices="() => {$emit('deviceReplacingLoadDevices')}"
                @update="(payload) => onUpdate(payload)"
              />

              <console
                ref="console"
                v-show="getPlaces[panel] == 'console'" 
                :data="getData"
              />

              <manage-device 
                v-if="getPlaces[panel] == 'manage'" 
                :data="getData"
                :template="getTemplate"
              />
            </v-layout>
          </v-layout>

          <v-dialog v-model="dialog.upload.show" max-width="50%" v-if="dialog.upload.show">
              <form-file-import
                :newFiles="dialog.upload.files"
                :files="getFiles"
                :activeObj="getData"
                @close="onFileImportClose()"
                @delete="(payload) => onFileDelete(payload)"
              />
          </v-dialog>
      </v-layout>
    </template>
  </scroll-area>
</template>

<script lang="ts">
import Vue from 'vue'
import EquipmentMeasures from '@/nms/components/equipment/equipment-measures.vue'
import ManageDevice from '@/nms/components/device-configuration/manage/manage-device.vue'
import Console from '@/nms/components/device-configuration/console/console.vue'
import DeviceCard from '@/nms/components/device/device-card.vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import FormFileImport from '@/nms/pages/forms/form-file-import.vue'
import { getURL } from '@/nms/plugins/bridge.js'
import { mapGetters } from 'vuex'

// Типы
interface ModelData {
  fields: Record<string, any>
  links: any[]
  template: any
}

interface DialogState {
  check: boolean
  loader: boolean
  message: { show: boolean; text: string }
  upload: { show: boolean; files: any[] }
  inventory: { show: boolean; tree: any[]; obj: Record<string, any> }
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: any[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface DashboardItem {
  title: string
  [key: string]: any
}

interface DeviceData {
  $id?: string
  cls?: string
  template?: string
  [key: string]: any
}

interface CurrentData {
  template?: Record<string, any>
  [key: string]: any
}

interface ChannelItem {
  $id?: string
  cls?: string
  getRefs?: () => Promise<any[]>
  endpoints?: any[]
  [key: string]: any
}

interface RefItem {
  ref?: string
  getParents?: () => Promise<any[]>
  [key: string]: any
}

export default Vue.extend({
  name: 'SHOW_DEVICE_BAR_FIELDS',

  components: {
    scrollArea,
    EquipmentMeasures,
    ManageDevice,
    Console,
    DeviceCard,
    FormFileImport,
  },

  props: {
    data: {
      type: Object as () => DeviceData,
      default: () => ({})
    },
    current: {
      type: Object as () => CurrentData,
      default: () => ({})
    },
    cabinet: {
      type: Object as () => any,
      default: () => ({})
    },
    closedUnits: {
      type: Array as () => any[],
      default: () => []
    },
  },

  data(): {
    showInventoryBar: boolean
    dashboards: DashboardItem[]
    selectedCls: string | null
    deviceShow: boolean
    deviceHeight: number
    sideView: string
    dialog: DialogState
    panel: number
    meta: Record<string, any>
    showRefs: boolean
    files: any[]
    model: ModelData
    webaccess: any | null
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      showInventoryBar: false,
      dashboards: [],
      selectedCls: null,
      deviceShow: false,
      deviceHeight: 45,
      sideView: 'front',
      dialog: {
        check: false,
        loader: false,
        message: { show: false, text: '' },
        upload: { show: false, files: [] },
        inventory: { show: false, tree: [], obj: {} },
      },
      panel: 0,
      meta: {},
      showRefs: false,
      files: [],
      model: {
        fields: {},
        links: [],
        template: {},
      },
      webaccess: null,
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          endpoint: { width: '40%' },
          check: { width: '20%' },
        },
      },
      search: '',
      table: {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '40%'
          },
          {
            title: 'type',
            value: 'type',
            type: 'text',
            width: '40%'
          },
          {
            title: 'status',
            value: 'status',
            type: 'status',
            width: '20%'
          },
        ],
        rows: []
      },
    }
  },

  computed: {
    getData(): DeviceData {
      return this.data
    },

    getActive(): any {
      return this.$store.state.devices.activeDevice ? this.$store.state.devices.activeDevice : this.data
    },

    getTemplate(): any {
      return this.model.template
    },

    getDeviceHeight(): any {
      return this.deviceHeight
    },

    getFiles(): any[] {
      return this.files.filter(file => {
        const description = file.data?.description
        return description && description.split('.').shift() !== 'image_$'
      })
    },

    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },

    getFields(): Record<string, any> {
      return this.model.fields
    },

    getLinks(): any[] {
      return this.model.links
    },

    getCurrentUser(): any {
      return this.$store.getters.getCurrentUser
    },

    getPlaces(): string[] {
      let places$$ = this.$store.getters.getPlaces.show.device
      let places$ = this.checkPage('channel')
        ? places$$
        : places$$.filter((place: string) => place !== 'channels' && place !== 'links')

      if (this.model.template && !this.model.template.webaccess) {
        places$ = places$.filter((place: string) => place !== 'webaccess')
      }
      if (this.model.template && (!this.model.template.bridges || !this.model.template.bridges.ssh)) {
        places$ = places$.filter((place: string) => place !== 'console')
      }
      if (this.model.template && (!this.model.template.tree || !this.model.template.tree.length)) {
        places$ = places$.filter((place: string) => place !== 'manage')
      }
      if (this.getCurrentUser?.role === 'operator') {
        places$ = places$.filter((place: string) => place !== 'manage' && place !== 'console')
      }

      const resPlaces = this.dashboards?.length
        ? [...this.dashboards.map(el => el.title), ...places$]
        : places$
      return resPlaces
    },

    ...mapGetters(['checkPage']),
  },

  watch: {
    data: {
      handler(newVal: DeviceData): void {
        // console.log(this.$options.name, 'WATCH', 'data', newVal)
        if (newVal) {
          this.setup('watch data')
        }
      },
      deep: true
    },
    '$store.state.file.upload.counter': {
      handler(): void {
        this.loadFiles()
      },
      deep: true
    },
  },

  beforeDestroy(): void {
    this.statusUnsubscribe('SHOW_DEVICE_BAR')
    this.statusUnsubscribe('channels')
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    async setup(caller: string): Promise<void> {
      console.log(this.$options.name, 'setup', 'caller', caller)
      this.showInventory(false)
      this.statusUnsubscribe('SHOW_DEVICE_BAR')
      this.statusUnsubscribe('channels')
      this.showRefs = false
      
      if(this.deviceShow) {
        this.deviceShow = false
      }

      if (this.getData.$id) {
        await this.loadMeta()
        await this.loadChannels()
        await this.loadFiles()
      }
      console.log(this.$options.name, 'setup', 'current', this.current)
    },

    async loadMeta(): Promise<void> {
      const obj = await this.$bridge.getObjectById(this.getData.$id)
      const templates = await this.$bridge.getTemplates(obj.cls, { id: obj.template })

      this.meta = await obj.meta()
      if (this.meta) {
        this.model = await this.$prepareMeta(this.meta, this.$options.name)
        this.$set(this.model, 'template', templates[0])

        if (this.getData.$id) {
          this.loadLinks()
        }
        this.prepareData()
      }
      console.log(this.$options.name, 'loadMeta', 'meta', this.meta)
      this.statusSubscribe(this.$options.name, [this.getData])
    },

    async loadChannels(): Promise<void> {
      const channels = await this.$bridge.customQuery('cmdb', 'services/channels/external', { id: this.getData.$id, type: 'channel' }, 'GET') as ChannelItem[]

      if (channels?.length) {
        this.setLoader('loadChannels', true)
        const rows: any[] = []

        for (const channel of channels) {
          if (channel.cls === 'channel') {
            const refs = await channel.getRefs?.()
            if (refs) {
              const endpoints: any[] = []
              for (const ref of refs) {
                if (ref.ref === 'endpoint') {
                  let point = ''
                  const parents = await ref.getParents?.()
                  if (parents) {
                    parents.forEach(parent => {
                      if (parent.cls === 'folder') return
                      if (parent.cls === 'location' && (parent.type === 'zone' || parent.type === 'subzone')) return
                      point = point + parent.name + '/'
                    })
                  }
                  endpoints.push({ path: point.slice(0, -1), obj: ref })
                }
              }
              channel.endpoints = endpoints
            }
            rows.push(channel)
          }
        }

        this.table.rows = rows
        this.setLoader('loadChannels', false)
        this.statusSubscribe('channels', this.table.rows)
      }
    },

    async loadFiles(): Promise<void> {
      try {
        this.setLoader('loadFiles', true)
        this.files = await this.$loadFiles(this.getData.$id)
        this.setLoader('loadFiles', false)
      } catch (err) {
        console.error('CATCH', this.$options.name, 'loadFiles', err)
        this.setLoader('loadFiles', false)
      }
    },

    async statusSubscribe(group: string, arr: any[]): Promise<void> {
      this.$store.dispatch('measuresSubscribeInit', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
      await this.$bridge.subscribe(arr.map(obj => obj.$id))
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id === this.getData.$id) {
        this.$emit('status', e)
      }
    },

    statusUnsubscribe(group: string): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: group,
        listener: 'status'
      })
    },

    async prepareData(): Promise<void> {
      try {
        const model = await this.$prepareData(this.model, this.getData, this.meta)
        // console.log(this.$options.name, 'prepareData', 'model JSON', JSON.parse(JSON.stringify(model)))
        this.model = model

        if (this.getData?.cls === 'unit' && this.current.template) {
          const fields = Object.keys(this.model.fields)
          fields.forEach(name => {
            if (this.current.template?.[name]) {
              this.$set(this.model.fields[name], 'value', this.current.template[name])
            }
          })
        }

        this.showRefs = true
      } catch (err) {
        console.error('CATCH', this.$options.name, 'prepareData', err)
        this.setLoader('prepareData', false)
      }
    },

    async loadLinks(): Promise<void> {
      this.model.links = []
      this.setLoader('loadLinks', true)

      const query = {
        id: [this.data.$id],
        notNull: true,
        data: {
          links: {
            flatten: false,
            data: {
              brefs: true,
              children: {
                data: {
                  brefs: true,
                  children: {
                    data: {
                      brefs: true,
                      children: {
                        data: {
                          brefs: true,
                          children: {
                            data: {
                              brefs: true,
                              children: {
                                data: { brefs: true }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }

      const obj = await this.$bridge.cmdbQuery(query) as any[]
      console.log(this.$options.name, 'loadLinks', 'obj$', obj)

      if (obj?.[0]) {
        obj[0].children = obj[0].links
        this.$set(this.model, 'links', obj)
        this.checkChildrenHeight(obj[0].children)
      }
      this.setLoader('loadLinks', false)
    },

    checkChildrenHeight(links: any[]): void {
      this.deviceHeight = this.getData.height || 45
      links.forEach(link => {
        if(link.height && link.height > this.deviceHeight) {
          this.deviceHeight = Number(link.height)
        }
      })
    },

    onFileDelete(id: string): void {
      this.dialog.upload.files.forEach((file, index) => {
        if (file.id === id) {
          this.dialog.upload.files.splice(index, 1)
        }
      })
      this.$bridge.deleteDocument(id)
      this.loadFiles()
    },

    onFileImportClose(): void {
      this.$set(this.dialog.upload, 'show', false)
      this.$set(this.dialog.upload, 'files', [])
    },

    onUpdate(payload: any): void {
      console.log(this.$options.name, 'onUpdate', payload)
      this.$emit('update', payload)
      this.loadLinks()
    },

    reconnectConsole(): void {
      console.log('refs', this.$refs)
      const consoleRef = this.$refs.console as any
      if (consoleRef?.reInitTerminal) {
        consoleRef.reInitTerminal()
      }
    },

    setLoader(name: string, status: boolean): void {
      this.$store.dispatch('setLoader', {
        key: name,
        value: status
      })
    },

    showInventory(val: boolean): void {
      const refs = this.$refs
      console.log(this.$options.name, 'showInventory', 'val', val)
      console.log(this.$options.name, 'showInventory', 'REFS', refs)

      const equipmentMeasures = refs['equipment-measures'] as any
      if (equipmentMeasures?.openInventoryBar) {
        equipmentMeasures.openInventoryBar(val)
        this.showInventoryBar = val
      }
    },

    onSelected(payload: any): void {
      console.log(this.$options.name, 'onSelected', payload)
      this.selectedCls = payload?.cls || null
      console.log(this.$options.name, 'this.selectedCls', this.selectedCls)
    },

    hideDeviceCard(): void {
      this.deviceShow = !this.deviceShow
      console.log(this.$options.name, 'hideDeviceCard', 'this.getData', this.getData)
    },
  },
})
</script>

<style lang="css" scoped>
.device_card_show_area {
  /* height: 240px; */
  width: 100%;
}

.device_hide_button {
  position: relative;
  height: 40px;
  width: 40px;
  margin-right: 4px;
  margin-left: 12px;
  border: solid 1px #9F9F9F !important;
  border-radius: 2px;
}

.device_hide_button_trigger_hide {
  position: absolute;
  height: 26px;
  width: 38px;
  border-top: solid 1px #9F9F9F !important;
  border-bottom: solid 1px #9F9F9F !important;
  padding-top: 2px;
  padding-left: 11px;
  bottom: 13px;
  border-radius: 2px;
}

.device_hide_button_trigger_show {
  position: absolute;
  height: 38px;
  width: 38px;
  padding-top: 8px;
  padding-left: 11px;
  border-radius: 2px;

}

</style>
